// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ═══════════════════════════════════════════════════════
   Navbar Styles
   ═══════════════════════════════════════════════════════ */
.Navbar_navbar__istqB {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding-top: var(--space-md);
  z-index: 1000;
  pointer-events: none;
  transition: all 0.3s ease;
}
.Navbar_navbar__container__gGbZ5 {
  pointer-events: auto;
  width: max-content;
  margin: 0 auto;
  padding: 10px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  border-radius: 9999px;
  border: 1px solid var(--color-rule);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
}
.Navbar_navbar__logo-link__q2A3v {
  display: flex;
  align-items: center;
}
.Navbar_navbar__logo__88sHw {
  height: 32px;
  transition: all 0.3s ease;
}
.Navbar_navbar__nav__Gws\\+z {
  display: flex;
  align-items: center;
  gap: 32px;
}
@media (max-width: 1024px) {
  .Navbar_navbar__nav__Gws\\+z {
    display: none;
  }
}
.Navbar_navbar__nav-link__D5Wp6 {
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--color-ink-2);
  text-decoration: none;
  transition: color 0.2s ease;
}
.Navbar_navbar__nav-link__D5Wp6:hover {
  color: var(--color-ink);
}
.Navbar_navbar__auth__usmJO {
  display: flex;
  align-items: center;
  gap: 16px;
}
@media (max-width: 1024px) {
  .Navbar_navbar__auth__usmJO {
    display: none;
  }
}
.Navbar_navbar__login-btn__mw4mL {
  background: transparent;
  border: none;
  font-size: 1rem;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
  transition: color 0.3s ease;
  font-family: inherit;
}
.Navbar_navbar__login-btn__mw4mL:hover {
  color: rgba(255, 255, 255, 0.8);
}
.Navbar_navbar__demo-btn__9yxHm {
  padding: 8px 20px;
  background: var(--color-ink);
  color: var(--color-paper);
  border-radius: 9999px;
  font-size: 0.95rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
}
.Navbar_navbar__demo-btn__9yxHm:hover {
  background: var(--color-accent);
  transform: translateY(-1px);
}
.Navbar_navbar__istqB {
  /* ─── Mobile Hamburger ─── */
}
.Navbar_navbar__hamburger__fhDUB {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1010;
}
@media (max-width: 1024px) {
  .Navbar_navbar__hamburger__fhDUB {
    display: flex;
  }
}
.Navbar_navbar__hamburger__fhDUB span {
  display: block;
  width: 100%;
  height: 2px;
  background: var(--color-ink);
  transition: all 0.3s ease;
  transform-origin: left center;
}
.Navbar_navbar__hamburger--open__2l6wZ span:first-child {
  transform: rotate(45deg);
}
.Navbar_navbar__hamburger--open__2l6wZ span:nth-child(2) {
  opacity: 0;
}
.Navbar_navbar__hamburger--open__2l6wZ span:last-child {
  transform: rotate(-45deg);
}
.Navbar_navbar__istqB {
  /* ─── Mobile Menu ─── */
}
.Navbar_navbar__mobile-menu__zrsWn {
  position: fixed;
  top: 0;
  right: -100%;
  width: 300px;
  height: 100vh;
  background: #ffffff;
  padding: 100px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  transition: right 0.3s ease;
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.1);
  z-index: 999;
}
.Navbar_navbar__mobile-menu--open__pQQ70 {
  right: 0;
}
.Navbar_navbar__mobile-link__vh4eq {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--accent-color);
  text-decoration: none;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--light-grey);
}
.Navbar_navbar__mobile-auth__2gx\\+N {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: auto;
}
.Navbar_navbar__mobile-auth__2gx\\+N .Navbar_navbar__demo-btn__9yxHm {
  text-align: center;
  padding: 14px;
}`, "",{"version":3,"sources":["webpack://./src/LandingPage/Layout/Navbar/Navbar.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;4DAAA;AAIA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,4BAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;AACF;AAEE;EACE,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,qCAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,0CAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;AADJ;AAIE;EACE,YAAA;EACA,yBAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAHJ;AAKI;EALF;IAMI,aAAA;EAFJ;AACF;AAKE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,2BAAA;AAHJ;AAKI;EACE,uBAAA;AAHN;AAOE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AALJ;AAOI;EALF;IAMI,aAAA;EAJJ;AACF;AAOE;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,oBAAA;AALJ;AAOI;EACE,+BAAA;AALN;AASE;EACE,iBAAA;EACA,4BAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AAPJ;AASI;EACE,+BAAA;EACA,2BAAA;AAPN;AA3FA;EAsGE,6BAAA;AARF;AASE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAPJ;AASI;EAXF;IAYI,aAAA;EANJ;AACF;AAQI;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,4BAAA;EACA,yBAAA;EACA,6BAAA;AANN;AAUM;EACE,wBAAA;AARR;AAUM;EACE,UAAA;AARR;AAUM;EACE,yBAAA;AARR;AA/HA;EA4IE,wBAAA;AAVF;AAWE;EACE,eAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;EACA,2CAAA;EACA,YAAA;AATJ;AAWI;EACE,QAAA;AATN;AAaE;EACE,iBAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;EACA,oBAAA;EACA,0CAAA;AAXJ;AAcE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAZJ;AAcI;EACE,kBAAA;EACA,aAAA;AAZN","sourcesContent":["/* ═══════════════════════════════════════════════════════\n   Navbar Styles\n   ═══════════════════════════════════════════════════════ */\n\n.navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding-top: var(--space-md);\n  z-index: 1000;\n  pointer-events: none;\n  transition: all 0.3s ease;\n\n\n  &__container {\n    pointer-events: auto;\n    width: max-content;\n    margin: 0 auto;\n    padding: 10px 24px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 40px;\n    background: rgba(255, 255, 255, 0.85);\n    backdrop-filter: blur(12px);\n    border-radius: 9999px;\n    border: 1px solid var(--color-rule);\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);\n  }\n\n  &__logo-link {\n    display: flex;\n    align-items: center;\n  }\n\n  &__logo {\n    height: 32px;\n    transition: all 0.3s ease;\n  }\n\n  &__nav {\n    display: flex;\n    align-items: center;\n    gap: 32px;\n\n    @media (max-width: 1024px) {\n      display: none;\n    }\n  }\n\n  &__nav-link {\n    font-size: 0.95rem;\n    font-weight: 500;\n    color: var(--color-ink-2);\n    text-decoration: none;\n    transition: color 0.2s ease;\n\n    &:hover {\n      color: var(--color-ink);\n    }\n  }\n\n  &__auth {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n\n    @media (max-width: 1024px) {\n      display: none;\n    }\n  }\n\n  &__login-btn {\n    background: transparent;\n    border: none;\n    font-size: 1rem;\n    font-weight: 500;\n    color: #ffffff;\n    cursor: pointer;\n    transition: color 0.3s ease;\n    font-family: inherit;\n\n    &:hover {\n      color: rgba(255, 255, 255, 0.8);\n    }\n  }\n\n  &__demo-btn {\n    padding: 8px 20px;\n    background: var(--color-ink);\n    color: var(--color-paper);\n    border-radius: 9999px;\n    font-size: 0.95rem;\n    font-weight: 500;\n    border: none;\n    cursor: pointer;\n    text-decoration: none;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background: var(--color-accent);\n      transform: translateY(-1px);\n    }\n  }\n\n  /* ─── Mobile Hamburger ─── */\n  &__hamburger {\n    display: none;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 24px;\n    height: 18px;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    z-index: 1010;\n\n    @media (max-width: 1024px) {\n      display: flex;\n    }\n\n    span {\n      display: block;\n      width: 100%;\n      height: 2px;\n      background: var(--color-ink);\n      transition: all 0.3s ease;\n      transform-origin: left center;\n    }\n\n    &--open {\n      span:first-child {\n        transform: rotate(45deg);\n      }\n      span:nth-child(2) {\n        opacity: 0;\n      }\n      span:last-child {\n        transform: rotate(-45deg);\n      }\n    }\n  }\n\n  /* ─── Mobile Menu ─── */\n  &__mobile-menu {\n    position: fixed;\n    top: 0;\n    right: -100%;\n    width: 300px;\n    height: 100vh;\n    background: #ffffff;\n    padding: 100px 24px 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    transition: right 0.3s ease;\n    box-shadow: -10px 0 30px rgba(0, 0, 0, 0.1);\n    z-index: 999;\n\n    &--open {\n      right: 0;\n    }\n  }\n\n  &__mobile-link {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: var(--accent-color);\n    text-decoration: none;\n    padding-bottom: 12px;\n    border-bottom: 1px solid var(--light-grey);\n  }\n\n  &__mobile-auth {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-top: auto;\n\n    .navbar__demo-btn {\n      text-align: center;\n      padding: 14px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `Navbar_navbar__istqB`,
	"navbar__container": `Navbar_navbar__container__gGbZ5`,
	"navbar__logo-link": `Navbar_navbar__logo-link__q2A3v`,
	"navbar__logo": `Navbar_navbar__logo__88sHw`,
	"navbar__nav": `Navbar_navbar__nav__Gws+z`,
	"navbar__nav-link": `Navbar_navbar__nav-link__D5Wp6`,
	"navbar__auth": `Navbar_navbar__auth__usmJO`,
	"navbar__login-btn": `Navbar_navbar__login-btn__mw4mL`,
	"navbar__demo-btn": `Navbar_navbar__demo-btn__9yxHm`,
	"navbar__hamburger": `Navbar_navbar__hamburger__fhDUB`,
	"navbar__hamburger--open": `Navbar_navbar__hamburger--open__2l6wZ`,
	"navbar__mobile-menu": `Navbar_navbar__mobile-menu__zrsWn`,
	"navbar__mobile-menu--open": `Navbar_navbar__mobile-menu--open__pQQ70`,
	"navbar__mobile-link": `Navbar_navbar__mobile-link__vh4eq`,
	"navbar__mobile-auth": `Navbar_navbar__mobile-auth__2gx+N`
};
export default ___CSS_LOADER_EXPORT___;
